import { Injectable, SecurityContext } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { CultureInfo } from '../../../core/culture-info';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class UploadedDocumentsRequestCreator {
    constructor(
        private readonly http: HttpClient,
        private sanitizer: DomSanitizer
    ) {
    }

    public createPost<T>(url: string, files: Map<File, CultureInfo>, documentMetadata: T): Observable<HttpEvent<Object>> {
        const formData = this.extractFileLanguageFormData(files);
        formData.append('documentMetadata', JSON.stringify(documentMetadata));

        const request = new HttpRequest('POST', url, formData, {reportProgress: true});

        return this.http.request(request);
    }

    public createPut(url: string, files: Map<File, CultureInfo>, auditTrailReason: string): Observable<HttpEvent<Object>> {
        const formData = this.extractFileLanguageFormData(files);
        formData.append('auditTrailReason', this.sanitizer.sanitize(SecurityContext.HTML, auditTrailReason));

        const request = new HttpRequest('PUT', url, formData, { reportProgress: true });

        return this.http.request(request);
    }

    private extractFileLanguageFormData(files: Map<File, CultureInfo>): FormData {
        const languages: CultureInfo[] = [];
        const fileContent = files.keys();
        const formData: FormData = new FormData();

        for (let file of fileContent) {
            formData.append('file', file, file.name);
            languages.push(files.get(file));
        }

        formData.append('fileLanguages', JSON.stringify(languages));
        return formData;
    }
}